import { createApp } from 'vue'
import App from '@/App.vue'
import utils from "@/utils/utils";

import { createI18n } from 'vue-i18n';
import messages from '@/languages'
import instruments from '@/instruments'

const i18n = createI18n({
    locale: 'gb',
    messages,
});


createApp(App).mixin(utils).mixin(instruments).use(i18n).mount('#app')